export default "__VITE_ASSET__DMZPU0RV__"